/**
 * @generated SignedSource<<1461407a680c96faeaf8aba804bac10d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenJoin_event$data = {
  readonly externalUrl: string | null | undefined;
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly myAttendance: {
    readonly status: EventAttendeeStatus;
  } | null | undefined;
  readonly owner: {
    readonly isMe?: boolean | null | undefined;
    readonly myMembership?: {
      readonly membershipLevel: GuildMembershipLevel;
    } | null | undefined;
  } | null | undefined;
  readonly venue: {
    readonly address: {
      readonly addressLine1: string | null | undefined;
      readonly addressLine2: string | null | undefined;
      readonly city: string | null | undefined;
      readonly countryCode: string | null | undefined;
      readonly formattedAddress: string | null | undefined;
      readonly location: {
        readonly geojson: any | null | undefined;
      } | null | undefined;
      readonly stateProvinceRegionCode: string | null | undefined;
      readonly zipPostalCode: string | null | undefined;
    } | null | undefined;
    readonly entryInstructions: string | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "EventScreenJoin_event";
};
export type EventScreenJoin_event$key = {
  readonly " $data"?: EventScreenJoin_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenJoin_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenJoin_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Venue",
      "kind": "LinkedField",
      "name": "venue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entryInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stateProvinceRegionCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipPostalCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formattedAddress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "location",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "geojson",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "membershipLevel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMe",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "be5c0312e9fa434f33f65a412e9aacc7";

export default node;
